import { useScreenState } from 'components/Screen';
import { useQueryCache } from 'query';

import { chart } from './queryKeyFactory';

export const useChartIsFetching = () => {
  const screenState = useScreenState();
  const { isFetching }: any =
    useQueryCache(
      chart({
        metrics: screenState.metrics,
        filters: screenState.filters,
      }),
      {
        exact: true,
      }
    ) || false;

  return isFetching;
};
